exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label {\n    font-size: 100%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/ecommerce/viewcategory/viewcategory.component.css
// module id = ../../../../../src/app/ecommerce/viewcategory/viewcategory.component.css
// module chunks = common